import { SET_ERROR } from './actionTypes';

export const setError = (error, code) => {
    return {
        type: SET_ERROR,
        error,
        code
    };
};